<template>
    <div class="charts-wrapper">
        <div class="chart-spacer" v-if="$parent.currentView === 'matchmaker-pos' && icGraphData && acGraphData"></div>
        <chart
            ref="ic-chart" refId="ic-chart" :graphData="icGraphData"
            :filteredValues="filteredICs" v-if="icGraphData && icGraphData.length > 0" color="#67c1cb" title="Institute/Center" filterField="agencies"/>
        <div class="matchmaker-chart-error-container" v-if="icGraphData && icGraphData.length === 0">
            <p>Insufficient Chart Data</p>
            <p>Remove filters for more results.</p>
        </div>
        <chart
            ref="ac-chart" refId="ac-chart" :graphData="acGraphData" :filteredValues="filteredACs" v-if="acGraphData && acGraphData.length > 0" color="#b4e2ba" title="Activity Code" filterField="activity_codes" />
        <div class="matchmaker-chart-error-container" v-if="acGraphData && acGraphData.length === 0">
            <p>Insufficient Chart Data</p>
            <p>Remove filters for more results.</p>
        </div>
        <template v-if="$parent.currentView === 'matchmaker-projects'">
            <chart
                ref="ss-chart" refId="ss-chart" :graphData="ssGraphData" :filteredValues="filteredSSs" v-if="ssGraphData && ssGraphData.length > 0" color="#f7bb6c" title="Study Section" filterField="study_sections" />
            <div class="matchmaker-chart-error-container" v-if="ssGraphData && ssGraphData.length === 0">
                <p>Insufficient Chart Data</p>
                <p>Remove filters for more results.</p>
            </div>
        </template>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
// import globalMixins from '@/globalMixins';
import chart from '@/components/matchmaker/MatchmakerChart.vue';

export default {
    name: 'MatchmakerCharts',
    // mixins: [globalMixins],
    components: {
      chart
    },
    data: function () {
        return {
            loadingGraphData: false,
            sharedSpecs: window.sharedSpecs
        };
    },
    computed: {
        ...mapGetters([
            'matchmakerFacetData',
            'matchmakerFacetCriteria',
            'matchmakerPOResults',
            'matchmakerResults',
            'searchMeta'
        ]),
        graphData: function () {
            // if (this.$parent.currentView === 'matchmaker-projects' && this.matchmakerFacetData) {
            //     return this.matchmakerFacetData.facets;
            if (this.$parent.currentView === 'matchmaker-projects' && this.$parent.matchmakerProjectsChartData) {
                return this.$parent.matchmakerProjectsChartData.facets;
            } else if (this.$parent.currentView === 'matchmaker-pos' && this.matchmakerPOResults) {
                return this.matchmakerPOResults.facet_results[0].chart_values;
            } else {
                return null;
            }
        },
        mappedFacetData: function () {
            if (this.graphData) {
                return this.graphData.map(el => el.name);
            } else {
                return [];
            }
        },
        icGraphData: function () {
            var tempInstituteData;

            if (this.mappedFacetData.length > 0) {
                tempInstituteData = copyData(this.graphData[this.mappedFacetData.indexOf('agencies')].values);
                // Sort values by count
                tempInstituteData.sort((a, b) => (a.count < b.count) ? 1 : -1);
                // Take top 6 institutes (omitting NIH as parent) to graph
                if (this.$parent.currentView === 'matchmaker-projects') {
                    tempInstituteData = tempInstituteData.slice(1, 7);
                } else {
                    tempInstituteData = tempInstituteData.slice(0, 6);
                }
            }

            return tempInstituteData;
        },
        acGraphData: function () {
            var tempActivityCodeData;

            if (this.mappedFacetData.length > 0) {
                tempActivityCodeData = copyData(this.graphData[this.mappedFacetData.indexOf('activity_codes')].values);

                // Sort values by count
                tempActivityCodeData.sort((a, b) => (a.count < b.count) ? 1 : -1);
                // Take top 6 Activity Codes to graph
                tempActivityCodeData = tempActivityCodeData.slice(0, 6);
            }

            return tempActivityCodeData;
        },
        ssGraphData: function () {
            var tempStudySectionData;

            if (this.mappedFacetData.length > 0) {
                tempStudySectionData = copyData(this.graphData[this.mappedFacetData.indexOf('study_sections')].values);

                // Sort values by count
                tempStudySectionData.sort((a, b) => (a.count < b.count) ? 1 : -1);
                // Take top 6 Study Sections to graph
                tempStudySectionData = tempStudySectionData.slice(0, 6);
            }

            return tempStudySectionData;
        },
        filteredICs: function () {
            var tempInstituteData = [];

            if (this.mappedFacetData.length > 0 && this.matchmakerFacetCriteria && this.matchmakerFacetCriteria.agencies) {
                tempInstituteData = copyData(this.matchmakerFacetCriteria.agencies);
            }

            return tempInstituteData;
        },
        filteredACs: function () {
            var tempActivityCodeData = [];

            if (this.mappedFacetData.length > 0 && this.matchmakerFacetCriteria && this.matchmakerFacetCriteria.activity_codes) {
                tempActivityCodeData = copyData(this.matchmakerFacetCriteria.activity_codes);
            }

            return tempActivityCodeData;
        },
        filteredSSs: function () {
            var tempStudySectionData = [];

            if (this.mappedFacetData.length > 0 && this.matchmakerFacetCriteria && this.matchmakerFacetCriteria.study_sections) {
                tempStudySectionData = copyData(this.matchmakerFacetCriteria.study_sections);
            }

            return tempStudySectionData;
        }
    },
    mounted () {
        let searchResults = copyData(this.matchmakerResults)
        if (this.$route.name == 'matchmaker-pos') {
            searchResults = copyData(this.matchmakerPOResults)
        }
        //if (!this.$parent.matchmakerProjectsChartData && this.searchResults) {
        if (!this.$parent.matchmakerProjectsChartData) {
            this.$parent.getMatchmakerProjectsChartData(false);
        }
    },
    methods: {
        ...mapActions([
            // 'setFullscreen',
            // 'setSearchMode',
            // 'setGraphData',
            // 'setGraphSettings'
        ]),
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/charts.scss';

.chartDataTable {
    .loading {
        background-color: $grey;
        opacity: 0.5;
        top: 0;

        .loader {
            top: 15%;
            left: 35%;
        }
    }
}

.matchmaker-chart-error-container {
    width: calc((1 / 3) * 100%);
    padding: 70px 10px;
    font-size: 14px;
    display: inline-block;
    text-align: center;
    vertical-align: top;

    p {
        font-size: 12px;
        &:first-of-type {
            font-size: 14px;
            font-weight: bold;
        }
    }
}

.chart-spacer {
    width: calc((1 / 6) * 100%);
    min-height: 1px;
    display: inline-block;
}

.charts-wrapper {
    width: 100%;
    position: relative;
    border-radius: 4px;
    margin: 5px 0px 10px;
    background-color: $white;
}
</style>
